<div style="display: inline-block" [tooltip]="'PUZZLE.time_info' | translate" placement="bottom" *ngIf="!device.isMobile()">
  <ion-text color="" class="timer-content" (click)="timerClicked()">
    <div class="info">{{'PUZZLE.time' | translate}}</div>
    <div class="info-value">{{this.timeString}}</div>
  </ion-text>
</div>

<ion-text color="" class="timer-content" (click)="timerClicked()" *ngIf="device.isMobile()">
  <div class="info">{{'PUZZLE.time' | translate}}</div>
  <div class="info-value">{{this.timeString}}</div>
</ion-text>
